import { Box, styled } from "@mui/material";

export const ActionInformationWrapper = styled(Box)`
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
`;
